"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIRST_PAGE = 1;
exports.ONE_PAGE = 1;
exports.ELLIPSIS = '...';
const addEllipsis = (siblings, page) => {
    const lastSibling = siblings[siblings.length - 1];
    if (lastSibling && lastSibling !== page) {
        siblings.push(exports.ELLIPSIS);
    }
};
const getPreviousSiblings = (activePage, siblingCount) => {
    const previousSiblings = [];
    const estimatedLastSibling = activePage - siblingCount;
    let pageNumber = activePage - exports.ONE_PAGE;
    for (; pageNumber >= estimatedLastSibling && pageNumber >= exports.FIRST_PAGE; pageNumber--) {
        previousSiblings.push(pageNumber);
    }
    addEllipsis(previousSiblings, exports.FIRST_PAGE);
    return previousSiblings.reverse();
};
const getNextSiblings = (activePage, siblingCount, totalPages) => {
    const nextSiblings = [];
    const estimatedLastSibling = activePage + siblingCount;
    let pageNumber = activePage + exports.ONE_PAGE;
    for (; pageNumber <= estimatedLastSibling && pageNumber <= totalPages; pageNumber++) {
        nextSiblings.push(pageNumber);
    }
    addEllipsis(nextSiblings, totalPages);
    return nextSiblings;
};
exports.getRange = (activePage, totalPages, siblingCount) => {
    const previousSiblings = getPreviousSiblings(activePage, siblingCount);
    const nextSiblings = getNextSiblings(activePage, siblingCount, totalPages);
    return [...previousSiblings, activePage, ...nextSiblings];
};
//# sourceMappingURL=range-utils.js.map